// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, put, del } from "./api_client";
import { DeviceCommand, IDeviceCommand, RelayTestSummary, IRelayTestSummary } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function sendCommand(command: DeviceCommand): ApiResult<boolean> {
	return put<boolean>(`/api/devicecommand`, command);
}

export async function resendCommand(id?: string): ApiResult<undefined> {
	return put(`/api/devicecommand/${ id }/resend`);
}

export async function getById(id?: string): ApiResult<DeviceCommand> {
	return get<IDeviceCommand>(`/api/devicecommand/${ id }`).then(result => result === undefined ? undefined :  new DeviceCommand(result));
}

export async function deleteById(id?: string): ApiResult<undefined> {
	return del(`/api/devicecommand/${ id }`);
}

export async function deleteAllPending(deviceId?: string): ApiResult<number> {
	return del<number>(`/api/devicecommand/device/${ deviceId }/pending`);
}

export async function getRecentRelayTests(since?: Date): ApiResult<RelayTestSummary[]> {
		const queryParams = [since !== undefined ? `since=${since.toISOString()}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IRelayTestSummary[]>(`/api/devicecommand/relay-tests${query}`).then(result => result === undefined ? undefined : result.map(o => new RelayTestSummary(o)));
}
